import { Component } from '@angular/core';

@Component({
    selector: 'app-verify-email-page',
    templateUrl: './verify-email-page.component.html',
    styleUrls: ['./verify-email-page.component.scss'],
})
export class VerifyEmailPageComponent {}
